<template>
  <div class="footer">
    <the-alerts />

    <footer>
      <v-container fluid>
        <v-row
          v-for="mMenu in menus.filter((menus) => menus.name === 'Footer')"
          :key="mMenu.priority"
        >
          <v-col cols="12" lg="4" md="12">
            <v-row class="align-center">
              <v-col cols="2" class="pb-0">
                <div class="logo-footer">
                  <img
                    :src="config.secondLogoAddress"
                    width="100%"
                    alt="logo of company"
                  />
                </div>
              </v-col>
              <v-col cols="10" class="pb-0">
                <h1 class="text-p-white">{{ config.title }}</h1>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0">
                <p
                  class="p-lh-m text-justify ps-lg-5"
                  v-html="page.shortDescription"
                ></p>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" sm="12" cols="12">
            <!-- <v-row class="justify-center align-center">
              <v-col lg="12" cols="6" class="d-flex justify-center">
                <div class="enemad">
                   <a
                    referrerpolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=525086&Code=pnujywOT2SRRRK8hl0odlNRTzt17xxG2"
                    ><img
                      referrerpolicy="origin"
                      src="https://trustseal.enamad.ir/logo.aspx?id=525086&Code=pnujywOT2SRRRK8hl0odlNRTzt17xxG2"
                      alt="enemad"
                      style="cursor: pointer"
                      code="pnujywOT2SRRRK8hl0odlNRTzt17xxG2"
                      width="100%"
                      height="100%"
                  /></a>
                </div>
              </v-col>
            </v-row> -->
            <v-row class="socials justify-start">
              <v-col
                cols="auto"
                v-for="item in socials.filter(
                  (z) => z.isActive && z.link.length > 1
                )"
                :key="item.id"
                class="text-center px-0"
              >
                <a class="pa-1 ml-1 social-item bg-p-muted" :href="item.link">
                  <v-img
                    :src="item.iconAddress"
                    contain
                    alt="icon of social network"
                  />
                </a>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="5"
            sm="6"
            lg="2"
            md="6"
            class="d-flex flex-column available-item mt-lg-3"
          >
            <h3>دسترسی سریع</h3>
            <ul class="mt-3 px-0 text-center">
              <li
                class="mb-3 text-start pr-2"
                v-for="menu in mMenu.children"
                :key="menu.id"
              >
                <router-link :to="menu.link" class="footer-menu p-fs-l">
                  {{ menu.text }}
                </router-link>
              </li>
            </ul>
          </v-col>
          <v-col cols="7" lg="4" md="6" sm="6" class="connection-text mt-lg-3">
            <h3>با ما در ارتباط باشید</h3>
            <v-row class="connection-item mt-lg-5">
              <v-col
                cols="12"
                class="connection-part d-flex align-center pr-0"
                v-if="config.tel"
              >
                <v-icon class="rotate-icon me-2"> mdi-phone-outline </v-icon>
                <span class="p-fs-xl text-p-white">{{ config.tel }} </span>
              </v-col>
              <v-col
                cols="12"
                class="connection-part d-flex align-center pr-0"
                v-if="config.email"
              >
                <v-icon class="me-2"> mdi-email-outline </v-icon>
                <span class="p-fs-xl text-p-white">{{ config.email }} </span>
              </v-col>
              <v-col
                cols="12"
                class="connection-part d-flex align-center pr-0"
                v-if="config.address"
              >
                <v-icon class="me-2"> mdi-map-marker-outline </v-icon>
                <span class="p-fs-m text-p-white">
                  {{ config.address }}
                </span>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="12" lg="2" md="12" class="mt-lg-3">
            <h3>خبرنامه</h3>
            <p class="mt-lg-4 mb-2">
              در خبرنامه ما عضو شوید و برای خرید بعدی جایزه دریافت کنید
            </p>
            <v-text-field
              placeholder="example@gmail.com"
              variant="outlined"
              color="#ffffff"
              hide-details
              dir="ltr"
              type="email"
              v-model="form.input"
              @keyup.enter="addSubscriber"
            >
            </v-text-field>
            <v-btn class="newsletter-btn" @click="addSubscriber">عضویت</v-btn>
          </v-col> -->
        </v-row>
        <hr class="hr-footer" v-if="config.copyright" />
        <v-row class="align-center" v-if="config.copyright">
          <v-col cols="12" lg="6" class="role-footer">
            <h6 class="p-fs-s p-fw-normal">
              {{ config.copyright }}
            </h6>
          </v-col>
          <!-- <v-col cols="12" lg="6" class="power-footer"> -->
          <!-- <p
              class="text-start mb-0 text-p-readonly p-fs-s p-fw-normal p-ff-en"
            >
              design and developed by
              <a href="https://parsinaco.com/" target="_blank">Parsina</a> -
              powered by PCMS v - {{ this.version }}
            </p> -->
          <!-- </v-col> -->
        </v-row>
        <!-- Add Modal -->
        <!-- <v-dialog v-model="addModal" max-width="400px" overlay-color="success">
          <v-card>
            <v-card-text class="px-2 py-0">
              <v-container>
                <v-row class="mt-1">
                  <v-col cols="7" class="d-flex align-center px-0">
                    <v-text-field
                      label="کد اعتبار سنجی"
                      name="captchaCode"
                      color="first"
                      hide-spin-buttons
                      outlined
                      class="text-center"
                      type="number"
                      v-model="form.captcha"
                      hide-details
                      dir="ltr"
                      @wheel="$event.target.blur()"
                    >
                    </v-text-field>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          plain
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click="reloadCaptcha"
                        >
                          <v-icon id="captchaRefreshTlp">mdi-reload</v-icon>
                        </v-btn>
                      </template>
                      <span>بارگذاری مجدد کپچا</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="5" class="d-flex align-center px-0">
                    <img
                      :src="captcha.dntCaptchaImgUrl"
                      alt="captcha"
                      class="radius-p-s"
                      height="56px"
                      width="100%"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mt-4" />
              </v-container>
            </v-card-text>
            <v-card-actions class="pt-0 mt-0">
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                text
                class="px-4"
                small
                @click="addModal = false"
              >
                {{ label.button.cancel }}
              </v-btn>
              <v-btn
                color="success"
                class="px-3"
                small
                depressed
                :loading="loadingBtn"
                @click="sendNewsLetter"
              >
                <v-icon small class="me-1">
                  mdi-checkbox-marked-circle-outline
                </v-icon>
                {{ label.button.submitInfo }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </v-container>
    </footer>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import TheAlerts from "@/components/TheAlerts";
import alert from "@/lang/AlertMessages.js";
import label from "@/lang/StaticLabels.js";

export default {
  name: "TheFooter",
  components: {
    TheAlerts,
  },
  computed: {
    ...mapGetters({
      menus: "baseX/menus",
      config: "baseX/config",
      socials: "clientX/socials",
      token: "panelX/token",
      page: "clientX/aboutUs",
      captcha: "captcha",
      loadingBtn: "loadingBtn",
      postCheck: "postCheck",
    }),
  },
  data() {
    return {
      alert,
      label,
      version: process.env.VUE_APP_VERSION,
      form: {
        input: null,
        captcha: null,
      },
      addModal: false,
    };
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.reloadFields();
        // this.reloadCaptcha();
      }
    },
  },
  methods: {
    // addSubscriber() {
    //   const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    //   if (this.form.input != null && this.form.input !== "") {
    //     if (emailRegex.test(this.form.input)) {
    //       this.addModal = true;
    //       this.reloadCaptcha();
    //     } else {
    //       this.$store.commit("setError", alert.error.wrongEmail);
    //     }
    //   } else {
    //     this.$store.commit("setError", alert.error.emptyEmail);
    //   }
    // },
    // sendNewsLetter() {
    //   let formData = new FormData();
    //   if (this.form.input != null && this.form.input !== "") {
    //     formData.append("Input", this.form.input);
    //     if (this.form.captcha && this.form.captcha.length > 0) {
    //       formData.append("CaptchaInputText", this.form.captcha);
    //       formData.append("CaptchaText", this.captcha.dntCaptchaTextValue);
    //       formData.append("CaptchaToken", this.captcha.dntCaptchaTokenValue);
    //       this.$store.dispatch("clientX/sendNewsLetter", formData);
    //     } else {
    //       this.$store.commit("setError", alert.error.captcha);
    //     }
    //   } else {
    //     this.$store.commit("setError", alert.error.emptyEmail);
    //   }
    // },
    // reloadCaptcha() {
    //   this.$store.dispatch("getClientCaptcha");
    //   this.form.captcha = null;
    // },
    reloadFields() {
      this.form = {
        input: null,
        captcha: null,
      };
      this.addModal = false;
    },
  },
  beforeCreate() {
    this.$store.dispatch("baseX/getMenus");
    this.$store.dispatch("baseX/getConfig");
    this.$store.dispatch("clientX/getAboutUs");
  },
};
</script>
